const items = [
  "Editorial",
  "Influence",
  "Audiences",
  "Storytelling",
  "Reach",
  "Distribution",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <section
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-[#27272A] bg-[#070707] py-10"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {row.map((word, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-5xl italic tracking-tight text-[#F5F5F0] md:text-7xl">
              {word}
            </span>
            <span className="mx-8 text-4xl text-[#E83D16] md:mx-12 md:text-5xl">
              +
            </span>
          </span>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
